import { render, staticRenderFns } from "./ManterMinutaAlterar.vue?vue&type=template&id=41cabd2b&scoped=true&"
import script from "./ManterMinutaAlterar.vue?vue&type=script&lang=js&"
export * from "./ManterMinutaAlterar.vue?vue&type=script&lang=js&"
import style0 from "./ManterMinutaAlterar.vue?vue&type=style&index=0&id=41cabd2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cabd2b",
  null
  
)

export default component.exports